const ResponsiveTables = (function () {
  let $tables = $("tables");
  let hasAddedWrapper = false;
  const wrapperClass = "table-wrapper";

  function init() {
    window.onload = function () {
      setTimeout(function () {
        $tables = $("main").find("table");
        addTableWrappers();
        addHorizontalScrollToWideTables();
        addLeftOrRightScrollShadowOnScroll();
      }, 200); // To ensure loading of IR-tables. Todo: Other solution?
    };

    window.onresize = function () {
      if ($tables.length > 0) {
        $tables.removeClass("horizontal-scroll");
        addHorizontalScrollToWideTables();
      }
    };
  }

  function addTableWrappers() {
    if (!hasAddedWrapper) {
      $tables.wrap("<div class=' " + wrapperClass + "'></div>");
      hasAddedWrapper = true;
    }
  }

  function addLeftOrRightScrollShadowOnScroll() {
    $tables.each(function () {
      $(this).on("scroll", function () {
        $(this).addLeftOrRightScrollShadow();
      });
    });
  }

  function addHorizontalScrollToWideTables() {
    $tables.each(function () {
      if (
        $(this)
          .closest("." + wrapperClass)
          .isOverflowing()
      ) {
        $(this).addClass("horizontal-scroll");
        $(this).addLeftOrRightScrollShadow();
      }
    });
  }

  $.fn.addLeftOrRightScrollShadow = function () {
    if ($(this).canScrollRight()) {
      $(this).addClass("scroll-right");
    } else {
      $(this).removeClass("scroll-right");
    }
    if ($(this).canScrollLeft()) {
      $(this).addClass("scroll-left");
    } else {
      $(this).removeClass("scroll-left");
    }
  };

  $.fn.isOverflowing = function () {
    return $(this)[0].clientWidth < $(this)[0].scrollWidth;
  };

  $.fn.canScrollLeft = function () {
    const scrollTolerance = 5;
    return $(this)[0].scrollLeft > scrollTolerance;
  };

  $.fn.canScrollRight = function () {
    const scrollTolerance = 5;
    return (
      $(this)[0].scrollLeft + $(this)[0].clientWidth <
      $(this)[0].scrollWidth - scrollTolerance
    );
  };

  return {
    init,
  };
})();

export default ResponsiveTables;
